import { createContext } from "react";

export const MainContext = createContext({
  data: {}, // Initial value
});

export const KantonContext = createContext({
  data: {}, // Initial value
});
